import { render } from "./TwoGrid.vue?vue&type=template&id=018d299b"
import script from "./TwoGrid.vue?vue&type=script&lang=js"
export * from "./TwoGrid.vue?vue&type=script&lang=js"

import "./TwoGrid.vue?vue&type=style&index=0&id=018d299b&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__